import { debugLog } from '@/helpers/loggingFunctions.js';
import { axiosAdapter } from '@/helpers/axiosAdapter';
import { useRoute } from 'vue-router';
import { getBrowserId } from "./authFunctions";

/**
 * Usage inside either a store or a vue file:
 *
 *		    return fetchEndpoint(
 *		    	thisStoreSelfObject,
 *		    	'/api/v1/project/' + this.selectedProjectUuid + '/models',
 *		    	'get',
 *		    	'models');
 *
 */
export async function fetchEndpoint(store, url, requestType, payload = null, storeProperty = null) {
    // debugLog('storeFunctions/fetchEndpoint - url : ' + url);

    const token = localStorage.getItem('access_token');
    axiosAdapter.defaults.headers.common['Authorization'] = !!token ? `Bearer ${token}` : '';
    axiosAdapter.defaults.headers.common['x-browser-id'] = getBrowserId();

    try {
        return new Promise((resolve, reject) => {
            // Check if the axiosAdapter supports the requestType method
            if (typeof axiosAdapter[requestType] !== 'function') {
                reject(new Error(`Request type ${requestType} is not supported`));
                return;
            }

            let requestPromise;

            if (requestType === 'get' || requestType === 'delete') {
                // For GET and DELETE requests, payload is not typically used
                requestPromise = axiosAdapter[requestType](url);
            } else {
                // For POST, PUT, PATCH, etc., send the payload along with the request
                requestPromise = axiosAdapter[requestType](url, payload);
            }

            requestPromise
                .then((response) => {
                    store.lastSuccessfulEventTimestamp = response.data.timestamp;

                    if (storeProperty) {
                        store[storeProperty] = response.data.data;
                    }

                    // debugLog('storeFunctions/fetchEndpoint - url : ' + url + ' - returning response');

                    resolve(response.data);
                })
                .catch((error) => {
                    let response = error.response;
                    axiosAdapter.actOnApiErrorResponse(response);
                    reject(response);
                });
        });
    } catch (error) {
        return error;
    }
}

export function assignEndpointResponse(targetPromise, store, storeProperty) {
    //  debugLog('storeFunctions/assignEndpointResponse - ' + storeProperty);

    try {
        return new Promise((resolve, reject) => {
            targetPromise.then((response) => {
                store[storeProperty] = response;
                resolve(response);
            });
        });
    } catch (error) {
        return error;
    }
}

export function fetchRouteParam(routeParam) {
    debugLog('storeFunctions/fetchRouteParam - ' + routeParam);

    const route = useRoute();
    let param = route.params[routeParam];

    debugLog('storeFunctions/fetchRouteParam - found: ' + param);

    return param;
}
